import commonActions from '@/store/data/common/actions'
import { webRequestClient } from '@/services'
import { isEmpty, get, head, toNumber } from 'lodash'
import helpers from './helpers'
import { errorHandler } from '@/utils/helpers'

const actions = {
    retrieveItems({ commit, rootState }) {
        commit('setIsLoading', true)
        const _route = helpers.buildRoutes(rootState.account)
        return webRequestClient
            .get(_route.route, _route.params)
            .then(accountsDsps => {
                if (get(accountsDsps, 'status') === 'KO') {
                    errorHandler('Error while retrieving account\'s dsps', commit)
                    return null
                } else {
                    if (!isEmpty(accountsDsps.list)) {
                        commit('setRetrievedItems', { items: helpers.parseData(accountsDsps.list, rootState.data.dsp.list) })
                    } else {
                        commit('ui/dsp/setZeroState', { zeroState: true }, { root: true })
                    }
                    return accountsDsps
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => {
                commit('setIsLoading', false)
            })
    },

    retrieveNewAccountsDsp({ commit, rootState }, params) {
        const _route = helpers.buildRoutes(rootState.account)
        commit('setIsLoading', true)
        return webRequestClient
            .get(_route.route, _route.params)
            .then(accountsDsps => {
                if (get(accountsDsps, 'status') === 'KO') {
                    errorHandler('Error while retrieving account\'s dsps', commit)
                } else {
                    if (!isEmpty(accountsDsps.list)) {
                        //add all accountsDsps to store
                        commit('setRetrievedItems', { items: helpers.parseData(accountsDsps.list, rootState.data.dsp.list) })
                        // no zero state
                        commit('ui/dsp/setZeroState', { zeroState: false }, { root: true })
                        //select newAccountDsp correspondig dsp
                        commit('ui/dsp/setSelectedDsp', { selectedDsp: toNumber(params.newDsp.dsp_id) }, { root: true })
                        //show new accountsDsps details
                        commit('ui/dsp/setSelectedRow', { rowId: params.newDsp.id }, { root: true })
                    } else {
                        commit('ui/dsp/setZeroState', { zeroState: true }, { root: true })
                    }
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => {
                commit('setIsLoading', false)
            })
    },

    createAccountsDsp({ commit, dispatch, rootState }, params) {
        const requestParams = { ...params, account_id: toNumber(rootState.account.accountId) }
        return webRequestClient
            .post('/audience_admin/accounts_dsps.json', requestParams)
            .then(newDsp => {
                if (get(newDsp, 'status') === 'KO') {
                    errorHandler('Error while creating your dsp', commit)
                    return 'failure'
                } else {
                    dispatch('retrieveNewAccountsDsp', { newDsp })
                    commit(
                        'notifications/setAddedNotification',
                        {
                            type: 'success',
                            message: `Partner "${params.label}" has been successfully created`
                        },
                        { root: true }
                    )
                    return 'success'
                }
            })
            .catch(error => {
                if (get(error, 'apiError.message', '').includes(' must be unique for values account_id ')) {
                    error = 'A configuration with the same dsp and identifier already exists'
                }
                errorHandler(error, commit)
            })
    },
    updateAccountsDsp({ commit, rootState }, params) {
        return webRequestClient
            .put(`/audience_admin/accounts_dsps/${rootState.ui.dsp.selectedRowId}.json`, { ...params })
            .then(response => {
                if (get(response, 'status', '') === 'KO' || isEmpty(response)) {
                    errorHandler('Error while updating your configuration', commit)
                    return 'failure'
                } else {
                    commit('setUpdatedAccountsDsp', { item: head(helpers.parseData([response], rootState.data.dsp.list)) })
                    commit('notifications/setAddedNotification', { type: 'success', message: 'Configuration has been successfully updated' }, { root: true })
                    return 'success'
                }
            })
            .catch(error => {
                if (get(error, 'apiError.message', '').includes(' must be unique for values account_id ')) {
                    error = 'A configuration with the same dsp and identifier already exists'
                }
                errorHandler(error, commit)
            })
    },
    getAccountsDsp({ commit, rootState }, id) {
        return webRequestClient
            .get(`/audience_admin/accounts_dsps/${id}.json`)
            .then(response => {
                if (get(response, 'status', '') === 'KO' || isEmpty(response)) {
                    errorHandler('Error while retrieving your configuration', commit)
                } else {
                    const item = head(helpers.parseData([response], rootState.data.dsp.list))
                    return item
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
    },
    deleteAccountsDsp({ commit, rootState }) {
        const id = rootState.ui.dsp.deletedConfigId
        return webRequestClient
            .delete(`/audience_admin/accounts_dsps/${id}.json`)
            .then(deletedConfig => {
                if (get(deletedConfig, 'status', '') === 'KO' || isEmpty(deletedConfig)) {
                    errorHandler(`Error while deleting configuration ${id}`, commit)
                } else {
                    commit('removeAccountsDsp', { id })
                    commit(
                        'notifications/setAddedNotification',
                        {
                            type: 'success',
                            message: 'Your configuration has been successfully deleted'
                        },
                        { root: true }
                    )
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => {
                commit('ui/dsp/setDisplayModal', { item: 'confirmation', display: false }, { root: true })
                commit('ui/dsp/setDeletedConfig', { id: null }, { root: true })
            })
    }
}

export default { ...commonActions, ...actions }
